module.exports = __webpack_public_path__ + "static/media/Image_Microsite_Consoles_70T.f66a7df0.png";